module.exports = __webpack_public_path__ + "56c4cb26fd6a48b9c0ebcc07b376ee38.ttf";